// extracted by mini-css-extract-plugin
module.exports = {"noReviews":"az_bRc","smallBody":"az_cRc","starsContainer":"az_dRc","stars":"az_eRc","star":"az_fRc","input":"az_gRc","starLine":"az_hRc"};